import http, { url } from '../../http'

const API_URL = "emergency_prevention_plan"

class prevencionEmergenciasAPI {

  async save(resource) {
    const response = await http(`${API_URL}/save`, 'POST', resource)
    return response
  }

  async getAll(id, page, search) {
    const response = await http(`${API_URL}/index/${id}?page=${page}&search=${search}`, 'POST')
    return response
  } 

  async getprevencion(id) {
    const response = await http(`${API_URL}/index/${id}`, 'POST')
    return response
  } 

/*   async getAll(id, page) {
    const response = await http(`${API_URL}/companies/${id}?page=${page}`)
    return response
  }  */
 
  async get(id) {
    const response = await http(`${API_URL}/${id}`)
    return response
  }

  async getPrevencion(id) {
    const response = await http(`${API_URL}/all/${id}`)
    return response
  }

  async update(id, resource) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', resource)
    return response
  }

  async delete(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response
  } 
  
}

export default new prevencionEmergenciasAPI()